import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { API_BASE_URL } from './auth.interceptor';

export type PlatformUserStatus = 'notProvisioned' | 'inactive' | 'active';

export interface PlatformTenant {
  readonly id: number;
  readonly code: string;
  readonly name: string;
}

export interface PlatformUser {
  readonly id: number;
  readonly name: string;
  readonly email: string;
  readonly tenants: readonly PlatformTenant[];
}

export interface CurrentUserResponse {
  readonly isAuthenticated: boolean;
  readonly cognitoSub: string | null;
  readonly email: string | null;
  readonly platformUserStatus: PlatformUserStatus;
  readonly platformUser: PlatformUser | null;
}

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL).replace(/\/$/, '');

  getCurrentUser(): Observable<CurrentUserResponse> {
    return this.http.get<CurrentUserResponse>(`${this.apiBaseUrl}/auth/me`);
  }
}